import { render, staticRenderFns } from "./EcarewaveIndex.vue?vue&type=template&id=bb5d6c88&scoped=true&"
import script from "./EcarewaveIndex.vue?vue&type=script&lang=js&"
export * from "./EcarewaveIndex.vue?vue&type=script&lang=js&"
import style0 from "./EcarewaveIndex.vue?vue&type=style&index=0&id=bb5d6c88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5d6c88",
  null
  
)

export default component.exports